import { isEqualWith, isFunction } from "lodash-es";
export const isEqualIgnoreFunctions = (o1, o2) => {
  const isEq = isEqualWith(o1, o2, function(val1, val2) {
    if (isFunction(val1) && isFunction(val2)) {
      return val1 === val2 || val1.toString() === val2.toString();
    }
    if (val1 && val1.constructor && val1.constructor.name === "FiberNode")
      return true;
  });
  return isEq;
};
